/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useContext, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import styles from "../../Emailer/Components/EmailerTable/EmailerTable.styles";
import Typography from "../../../components/common/new/Typography/Typography";
// import Button from "../../../components/common/Button";
// import Loader from "../../../components/common/Loader/Loader";
import { AlertStatus } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Table from "../../../components/common/new/Table/Table";
// import { ROUTES } from "../../../utils/constants";
// import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import EyeIcon from "../../../assets/svg/Eye";
// import Delete from "../../../assets/svg/Delete";
import Member from "../../../services/api/member";
import Button from "../../../components/common/Button";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = ({
  searchData,
  currentPage,
  pageSize,
  onMemberStatusToggle,
  onRejectDeactivation,
}) => {
  if (!searchData || searchData.length === 0) {
    return (
      <TableRow style={{ padding: "8px", height: "200px" }}>
        <TableCell colSpan={6} align="center">
          <Typography
            weight={600}
            style={{
              fontSize: "18px",
              color: "#000000",
              padding: "4px",
            }}
          >
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return searchData.map((memberInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow key={memberInfo?.member?.id}>
        <TableCell style={tabelCellWidth.tiny}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.tiny}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo?.member?.id ?? memberInfo?.member?.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo?.member?.fullName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.member?.emailId}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ maxWidth: "12rem" }}>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${memberInfo?.member?.areaName || "NA"} / ${
                memberInfo?.member?.zoneName || "NA"
              } / ${memberInfo?.member?.regionName || "NA"} / ${
                memberInfo?.member?.chapterName || "NA"
              } / ${memberInfo?.member?.districtName || "NA"}`}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: 10,
            }}
          >
            <EyeIcon
              style={{ ...styles.actionIcon, marginTop: "8px" }}
              onClick={() => onMemberStatusToggle(memberInfo)}
            />
            <Button
              variant="outlined"
              label="REJECT"
              style={{
                ...styles.actionIcon,
                maxWidth: "80px",
              }}
              onClick={() => onRejectDeactivation(memberInfo)}
            >
              {" "}
              REJECT
            </Button>
            {/* <Delete
              style={{ ...styles.actionIcon, marginTop: "4px" }}
              onClick={() => {
                onRejectDeactivation(memberInfo);
              }}
            /> */}
          </div>
        </TableCell>
      </TableRow>
    );
  });
};

function VerificationTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  showStatusColumn,
  // totalElements,
  selectedMember,
  onRefresh,
  onRejectDeactivation,
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  // const templateInfo = useSelector((state) => state.templateInfo.templateInfo);
  // const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  // const navigate = useNavigate();
  console.log("selectedMember", selectedMember);
  // const disableBtn = !searchData || searchData.length === 0;

  const toggleItemSelection = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  const onDelete = async (id) => {
    try {
      await Member.rejectDeactivation({ applicationId: id });
      toast.show("Recipient deleted Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  const columns = [
    {
      displayName: "S.No",
      key: "s.no",
    },
    {
      displayName: "Member ID",
      key: "id",
    },
    {
      displayName: "Name",
      key: "fullName",
    },
    {
      displayName: "Email",
      key: "email",
    },
    {
      displayName: "Org Structure",
      key: "orgstructure",
    },
    {
      displayName: "Action",
      key: "action",
    },
  ];

  return (
    <div style={styles.container}>
      {/* <Box style={styles.recipientsContainer}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            style={{ ...CommonStyles.buttonStyle, width: "150px" }}
            label="Send Email"
            disabled={disableBtn}
            onClick={handleSendEmail}
          />
        </Box>
      </Box> */}
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          onMemberStatusToggle,
          showStatusColumn,
          selectedItems,
          toggleItemSelection,
          onDelete,
          onRejectDeactivation,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{ ...styles.tableHeadCells, textAlign: "center" }}
      />
      {/* {isLoading && <Loader />} */}
    </div>
  );
}

export default VerificationTable;
